// extracted by mini-css-extract-plugin
export default {"container":"OP-z","topReviewHeading":"PP-z","criticalReview":"QP-z","favorableReview":"RP-z","vsSeparator":"SP-z"};